<template>
  <div class="container in-infor-wrap">
    <div class="container__content">
      <div class="container__border"></div>
      <div class="container__title">实时进场车辆信息</div>
    </div>
    <div class="in-infor">
      <div class="in-infor-bg">
        <img
          v-if="inInfo && inInfo.url"
          :src="inInfo.url"
          alt=""
        />
        <img
          v-else
          src="../../../../../assets/image/vehicle/img-null.png"
          class="none"
          alt=""
        />
      </div>
      <div class="in-infor-detail">
        <div class="icon">
          <img
            :src="inImg"
            alt=""
          />
        </div>
        <div class="item">入口位置：{{ inInfo && inInfo.position ? inInfo.position : "暂无数据" }}</div>
        <div class="item">车牌号码：{{ inInfo && inInfo.carCode ? inInfo.carCode : "暂无数据" }}</div>
        <div class="item">进场时间：{{ inInfo && inInfo.recordTime ? inInfo.recordTime : "暂无数据" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import gif from "../../../../../assets/image/vehicle/in.gif"
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      inImg: gif,
    }
  },
  computed: {
    ...mapGetters(["inInfo"]),
  },
  watch: {
    inInfo(v, o) {
      this.inImg = gif
      setTimeout(() => {
        this.inImg = png
      }, 1500)
    },
  },
}
</script>

<style lang="less" scoped>
.in-infor-wrap {
  height: 468px;
  position: relative;
}
.in-infor {
  height: 412px;
  padding: 20px 16px 22px;
  box-sizing: border-box;
  &-bg {
    position: relative;
    height: 226px;
    width: 383px;
    padding: 8px;
    box-sizing: border-box;
    background-image: url("../../../../../assets/image/vehicle/inout.png");
    background-size: 100% 100%;
    img {
      width: 100%;
      height: 100%;
    }
    .none {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 72px;
      height: 72px;
    }
  }
  &-detail {
    padding: 17px 0px 17px 32px;
    margin-top: 16px;
    box-sizing: border-box;
    .icon {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .item {
      margin-bottom: 18px;
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
    }
    :last-child {
      margin-bottom: 0;
    }
  }
}
</style>
